import { useEffect, useRef, useState } from "react";
import usePilotName from "../hooks/usePilotName";
import { useLens } from "../lens/LensProvider";
import PilotChooser from "./PilotChooser";
import PinIcon from "./PinIcon";

export default function PilotChip() {
  const { pinnedUid, pin, unpin } = useLens();
  const [menuOpen, setMenuOpen] = useState(false);
  const [choosing, setChoosing] = useState(false);
  const root = useRef<HTMLDivElement>(null);
  const name = usePilotName(pinnedUid);

  useEffect(() => {
    if (!menuOpen) return;
    const away = (e: MouseEvent) => { if (root.current && !root.current.contains(e.target as Node)) setMenuOpen(false); };
    const close = () => setMenuOpen(false);
    document.addEventListener("mousedown", away);
    window.addEventListener("hashchange", close);
    return () => { document.removeEventListener("mousedown", away); window.removeEventListener("hashchange", close); };
  }, [menuOpen]);

  const chooser = choosing && <PilotChooser onClose={() => setChoosing(false)} onSelect={uid => { pin(uid); setChoosing(false); }} />;

  if (!pinnedUid) {
    return <div className="pilot-chip">
      <button type="button" className="pilot-chip-button" onClick={() => setChoosing(true)} aria-label="Find your pilot">
        <PinIcon /><span className="pilot-chip-name">Find your pilot</span>
      </button>
      {chooser}
    </div>;
  }

  return <div className="pilot-chip" ref={root}>
    <button type="button" className="pilot-chip-button is-pinned" aria-expanded={menuOpen} aria-haspopup="true"
      aria-label={`${name}: pilot menu`} onClick={() => setMenuOpen(v => !v)}>
      <PinIcon /><span className="pilot-chip-name">{name}</span>
    </button>
    {menuOpen && <div className="pilot-chip-menu" role="menu">
      <a role="menuitem" href={`#/pilots/${encodeURIComponent(pinnedUid)}`} onClick={() => setMenuOpen(false)}>Profile</a>
      <button role="menuitem" type="button" onClick={() => { setMenuOpen(false); setChoosing(true); }}>Change pilot</button>
      <button role="menuitem" type="button" onClick={() => { setMenuOpen(false); unpin(); }}>Unpin</button>
    </div>}
    {chooser}
  </div>;
}
